import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import * as amplitude from 'amplitude-js';

import {
  ClientSubscriptionDTO,
} from '@/api';
import services from '@/services';

@Module({ name: 'SubscriptionModule' })
export default class SubscriptionModule extends VuexModule {
  list: ClientSubscriptionDTO[] = [];

  @Mutation
  setList(list: ClientSubscriptionDTO[]) {
    this.list = list;
  }

  @Action({ rawError: true })
  async fetchSubscriptions(clientId: number) {
    const { data } = await services.clientsService()
      .clientEndpointGetClientSubscription(clientId);
    this.setList(data);
    amplitude.getInstance().logEvent('Загрузка подписок', clientId);
    return data;
  }
}
